import React, { Component, createRef } from "react";
import Router from "next/router";
import { logout } from "../../../lib/logout";
import commonFunction from "../../../lib/utils/common";

const reportsArray = [
  "Booking Reports",
  "Ledger",
  "Cancellation Reports",
  "Outstanding Reports",
  "Detail Reports",
];
const ReportType = {
  Ledger: "Ledger",
  "Booking Reports": "Booking_Reports",
  "Cancellation Reports": "Cancellation_Reports",
  "Outstanding Reports": "Outstanding_Reports",
  "Detail Reports": "Detail_Reports",
};
class Menu extends Component {
  constructor(props) {
    super(props);
    this.menusWrapper = createRef();
    this.state = {
      hamburgerOpen: this.props.isopen,
      showreport : false
    };
    this.router = this.props.data.router;
    this.showlogout = true;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
  }
  handleClickOutside = (event) => {
    if (
      this.menusWrapper.current &&
      !this.menusWrapper.current.contains(event.target)
    ) {
      this.props.closeMenusHandler(false);
    }
  };
  onclose = () => {
    this.props.closeMenusHandler(false);
  };

  toggleHamburger = () => {
    this.setState({ hamburgerOpen: !this.state.hamburgerOpen });
  };

  handleSubmenu = () => {
    this.setState({ showreport: !this.state.showreport });
  };
  onClickRedirect = (data, index) => {
    if (data.href == "Logout") {
      this.props.onclickLogout();
    } else {
      this.setState({ showlogout: true });
      this.props.clickedTab(index);
      if (data.activeTab == "reports") {
        window.location.href = `/myprofile?activeTab=${data.activeTab}&ReportType=Booking_Reports`;
      } else {
        window.location.href = `/myprofile?activeTab=${data.activeTab}`;
      }
    }
  };

  onClickProfile = () => {
    this.props.clickedTab(0);
    commonFunction.redirectTo("/myprofile");
  };

  closeLogout = () => {
    this.setState({ showlogout: false });
  };

  onClickLogout = () => {
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status === true ||
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            userFirststname: "",
            userType: "",
          });
          location.reload();
          commonFunction.redirectTo("/");
        } else {
        }
      })
      .catch((err) => {
        console.log("errrrrrrrrrrr", err);
      });
  };

  myBookingClickHandler = () => {
    window.location.href = `/myprofile?Linkindex=2`;
  };
  homeClickHandler = () => {
    window.location.href = `/`;
  };

  handleReport = (Id) => [
    window.location.href = `/myprofile?activeTab=reports&ReportType=${ReportType[Id]}`
  ];

  render() {
    return (
      <div>
        {this.props.isopen && (
          <div
            ref={this.menusWrapper}
            className={`${this.props.styles.navigation_ineline} ${this.props.isopen ? this.props.styles.open_navbar : ""}`}
          >
            <span
              className={this.props.styles.close_icon}
              onClick={this.onclose}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="12" fill="#E5E9EF" />
                <path
                  d="M8.26671 16.6666L7.33337 15.7333L11.0667 11.9999L7.33337 8.26659L8.26671 7.33325L12 11.0666L15.7334 7.33325L16.6667 8.26659L12.9334 11.9999L16.6667 15.7333L15.7334 16.6666L12 12.9333L8.26671 16.6666Z"
                  fill="#212121"
                />
              </svg>
            </span>

            {this.props.MenuList.length > 0 &&
              this.props.MenuList.map((element, index) => {
                var activeTab = false;
                var activeTabReport = false;
                if (this.router.query.activeTab == element.activeTab) {
                  activeTab = true;
                  if (element.activeTabReport) {
                    activeTabReport = true;
                  }
                }
                return (
                  <>
                    <div className={this.props.styles.menu_item}>
                      <div
                        className={`${this.props.styles.mob_brd} ${
                          activeTab &&
                          this.props.styles.profile__sidebar_link_active
                        }`}
                        key={"menulist" + index}
                        onClick={() => {
                          this.onClickRedirect(element, index);
                        }}
                      >
                        <div className={this.props.styles.mobile_sidenav}>
                          <span
                            className={`${this.props.styles.my_settings_section_card_icon} ${this.props.styles.bui_u_margin8}`}
                          >
                            <img
                              src={element.imgActiveSrc}
                              alt={"imapo"}
                              width="20"
                              height="20"
                            />{" "}
                          </span>
                          <a
                            id="myprofile"
                            role="button"
                            className={this.props.styles.menu_item}
                          >
                            {element.linkItem}
                          </a>
                        </div>
                      </div>
                      {element.linkItem == "Reports" && (
                        <span
                          className={`${
                            this.state.showreport
                              ? this.props.styles.arrow_up
                              : this.props.styles.arrow_down
                          } ${this.props.styles.arrow}`}
                          onClick={this.handleSubmenu}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.239 6L3 7.20306L10 14L17 7.20306L15.761 6L10 11.5939L4.239 6Z"
                              fill="#FFF"
                            />
                          </svg>
                        </span>
                      )}
                    </div>
                    {element.linkItem == "Reports" && this.state.showreport && (
                      <div className={this.props.styles.reports_navigation}>
                        <ul
                          className={this.props.styles.reports_navigation_list}
                        >
                          {reportsArray.map((item, index) => {
                            var activeTabLink = false;
                            if (
                              this.router.query.ReportType.replace("_", " ") ==
                              item
                            ) {
                              activeTabLink = true;
                            }
                            return (
                              <li
                                key={index}
                                onClick={() => this.handleReport(item)}
                                className={`${this.props.styles.mob_brd} ${
                                  activeTabLink &&
                                  this.props.styles.profile__sidebar_link_active
                                }`}
                              >
                                <span key={index}>{item}</span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </>
                );
              })}
          </div>
        )}
      </div>
    );
  }
}

export default Menu;
